import { useState, useEffect, useRef } from 'react';

export const useDelayedRender = (flag, delay = 300) => {
  const [shouldRender, setShouldRender] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (flag) {
      timeoutRef.current = setTimeout(() => {
        setShouldRender(true);
      }, delay);
    } else {
      setShouldRender(false);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [flag, delay]);

  return shouldRender;
};
